
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      buttonTabs: [],
      selected: '',
      delaySelected: '',
      disableButton: false,
    }
  },
  watch: {
    selected: {
      handler(next) {
        if (next) {
          this.transitionAnim()

          // delay data change to allow animation transition to run first
          setTimeout(() => {
            this.delaySelected = next
          }, 700)
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setInitialData()
      this.initAnimation()
    })
  },
  methods: {
    initAnimation() {
      const tl = this.$gsap.timeline({
        scrollTrigger: {
          // markers: true,
          trigger: this.$refs.tablist,
          start: 'center bottom',
        },
      })

      tl.from(this.$refs.tabpanel, {
        duration: 0.6,
        alpha: 0,
      })
    },
    setInitialData() {
      this.selected = this.blok.tabs[0]._uid
      this.delaySelected = this.blok.tabs[0]._uid
      this.buttonTabs = this.blok.tabs.map((x) => ({
        id: x._uid,
        label: x.label,
        logo_active: x.logo_active,
        logo_inactive: x.logo_inactive,
        logo_classes: x.logo_classes || '',
        logo_mobile_classes: x.logo_mobile_classes || '',
      }))
    },
    setSelected(id) {
      this.selected = id
    },
    toggleDisableBtn() {
      this.disableButton = !this.disableButton
    },
    transitionAnim() {
      const tl = this.$gsap.timeline({
        onStart: () => this.toggleDisableBtn(),
        onComplete: () => this.toggleDisableBtn(),
      })

      tl.to(this.$refs['loading-screen'], {
        duration: 0.5,
        width: '100%',
        left: '0%',
        ease: 'Expo.easeInOut',
      })

      tl.to(this.$refs['loading-screen'], {
        duration: 0.5,
        width: '100%',
        left: '100%',
        ease: 'Expo.easeInOut',
        delay: 0.2,
      })

      tl.set(this.$refs['loading-screen'], { left: '-100%' })

      tl.from(this.$refs['bg-img'], {
        duration: 1,
        scale: 1.4,
        ease: 'Power2.easeInOut',
        delay: -0.9,
      })

      tl.from(this.$refs.content, {
        duration: 1,
        scale: 1.2,
        ease: 'Power2.easeInOut',
        delay: -1.3,
      })
    },
  },
}
